import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LOG_CONTEXT } from '@rms/core/http';
import { environment } from '@rms/env';
import { map, Observable } from 'rxjs';

import { LoginResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly http = inject(HttpClient);

  public login(username: string, password: string): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      `${environment.apiEndpoint}/v1/auth/token`,
      { grant_type: 'token', username, password },
      { context: new HttpContext().set(LOG_CONTEXT, 'AuthApiService.login') }
    );
  }

  public logout(): Observable<void> {
    return this.http
      .post(`${environment.apiEndpoint}/v1/auth/logout`, null, {
        context: new HttpContext().set(LOG_CONTEXT, 'AuthApiService.logout'),
      })
      .pipe(map(() => undefined));
  }

  public requestOneTimePassword(email: string): Observable<void> {
    return this.http.post<void>(
      `${environment.apiEndpoint}/v1/auth/otp`,
      { email, delivery_type: 'email' },
      { context: new HttpContext().set(LOG_CONTEXT, 'AuthApiService.requestOneTimePassword') }
    );
  }

  public resetPassword(email: string, password: string, otp: string): Observable<void> {
    return this.http.put<void>(
      `${environment.apiEndpoint}/v1/auth/credentials`,
      { email, password, otp },
      { context: new HttpContext().set(LOG_CONTEXT, 'AuthApiService.resetPassword') }
    );
  }
}
